import {Injectable} from '@angular/core';

export interface SingleEditTrackable {
    disableEdit(): void;
}

@Injectable({
    providedIn: 'root'
})
export class SingleEditEnforcer {
    private instances: SingleEditTrackable[] = [];

    registerTrackable(instance: SingleEditTrackable) {
        this.instances.push(instance);
    }

    unregisterTrackable(instance: SingleEditTrackable) {
        const index = this.instances.indexOf(instance);
        if (index > -1) {
            this.instances.splice(index, 1);
        }
    }

    disableAllExcept(instance: SingleEditTrackable) {
        for (let trackable of this.instances) {
            if (trackable !== instance) {
                trackable.disableEdit();
            }
        }
    }
}
